export default __webpack_public_path__ + "static/media/camera-1.0d6c0f83.png";